import { render, staticRenderFns } from "./indexinfotable.vue?vue&type=template&id=0d7a6fde&scoped=true&"
import script from "./indexinfotable.vue?vue&type=script&lang=js&"
export * from "./indexinfotable.vue?vue&type=script&lang=js&"
import style0 from "./indexinfotable.vue?vue&type=style&index=0&id=0d7a6fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7a6fde",
  null
  
)

export default component.exports